<template>
  <b-row>
    <b-col>
      <b-card>
        <b-row>
          <b-col md="12" class="pb-0"><h4>Company Info</h4></b-col>
          <b-col md="6" class="dotted-border-right dotted-border-bottom">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light">Name : </span>
                <span>{{ companyName }}</span>
              </h4>
            </div>
          </b-col>
          <b-col md="6" class="dotted-border-bottom">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light"
                  >Access Level :
                </span>
                <span>Global</span>
              </h4>
            </div>
          </b-col>
          <b-col md="12" class="dotted-border-bottom">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light">Address : </span>
                <span
                  >{{ companyCity }}, {{ companyStreet1 }}, {{ companyState }},
                  {{ companyZip }}</span
                >
              </h4>
            </div>
          </b-col>
          <b-col md="6" class="dotted-border-right">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light">Phone # : </span>
                <span
                  ><router-link to="" class="text-dark">{{
                    companyPhone
                  }}</router-link></span
                >
              </h4>
            </div>
          </b-col>
          <b-col md="6">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light"
                  >Email Id :
                </span>
                <span
                  ><router-link to="" class="text-dark">{{
                    companyEmail
                  }}</router-link></span
                >
              </h4>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-row>
          <b-col md="12" class="pb-0"><h4>Agreement</h4></b-col>
          <b-col md="6" class="dotted-border-right dotted-border-bottom">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light"
                  >Category Type :
                </span>
                <span>{{ agreeCategoryType }}</span>
              </h4>
            </div>
          </b-col>
          <b-col md="6" class="dotted-border-bottom">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light">Catalog : </span>
                <span>Grocery, Healthcare</span>
              </h4>
            </div>
          </b-col>
          <b-col md="12">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light"
                  >Agreement Period :
                </span>
                <span
                  ><router-link to="" class="text-dark"
                    >{{ AgreementFrom | formatedate }} To
                    {{ AgreementTo | formatedate }} ( {{ diffInDays }} months
                    left )</router-link
                  ></span
                >
              </h4>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-row>
          <b-col md="12" class="pb-0"><h4>Credential</h4></b-col>
          <b-col md="6" class="dotted-border-right">
            <div class="d-flex">
              <h4>
                <span class="text-secondary font-weight-light">
                  User Name :
                </span>
                <span>{{ companyUserName }}</span>
              </h4>
            </div>
          </b-col>
          <b-col md="6" class="">
            <div class="d-flex">
              <h4 class="text-secondary font-weight-light">Password :</h4>
              <button
                type="button"
                class="btn btn-lg btn-outline-primary w-15"
                @click="onClickChangePassword"
              >
                Change Password
              </button>
            </div>
            <ValidationObserver v-slot="{ invalid }">
              <b-modal
                title="Change Your Password"
                id="changePassword"
                ref="change-password"
                size="md"
                centered
                hide-footer
              >
                <label>Email</label>
                <div v-if="errors.length">
                  <ul class="validation-error mb-3">
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  name="Email"
                >
                  <b-input
                    class="mb-2"
                    type="email"
                    name="email"
                    id="email"
                    v-model="enterEmail"
                    placeholder="Enter Your Email"
                    required
                  ></b-input>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="text-center mt-2">
                  <button
                    type="button"
                    :disabled="invalid"
                    class="text-uppercase btn btn-lg btn-primary"
                    @click="generateOTP"
                  >
                    Submit
                  </button>
                </div>
              </b-modal>
            </ValidationObserver>
            <ValidationObserver v-slot="{ invalid }">
              <b-modal
                title="Create New Password"
                id="newPassword"
                ref="new-password"
                size="md"
                centered
                hide-footer
              >
                <div v-if="errors.length">
                  <ul class="validation-error mb-3">
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <label>New Password</label>
                <ValidationProvider
                  rules="required|max:12|min:3"
                  v-slot="{ errors }"
                  name="Password"
                >
                  <div class="password-input-container">
                    <b-input
                      class="mb-2"
                      placeholder="Enter Your New Password"
                      v-model="newPassword"
                      :type="showPassword ? 'text' : 'password'"
                      id="new-Password"
                      name="Password"
                      required
                    ></b-input>
                    <img
                      :src="
                        showPassword
                          ? require('@/assets/icon/passwordHideIcon.svg')
                          : require('@/assets/icon/passwordViewIcon.svg')
                      "
                      @click="togglePasswordVisibility"
                      class="toggle-password-icon"
                      alt="Toggle Password"
                    />
                  </div>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
                <label>OTP</label>
                <ValidationProvider
                  rules="required|numeric|max:12|min:4"
                  v-slot="{ errors }"
                  name="OTP"
                >
                  <b-input
                    class="mb-2"
                    id="OTP"
                    type="number"
                    v-model="enterOTP"
                    placeholder="Enter Your OTP"
                    name="OTP"
                    required
                  ></b-input>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="text-center mt-2">
                  <button
                    type="button"
                    :disabled="invalid"
                    class="text-uppercase btn btn-lg btn-primary"
                    @click="savePassword"
                  >
                    Submit
                  </button>
                </div>
              </b-modal>
            </ValidationObserver>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import loader from "@/components/loader/nipigeloader.vue";
import currentUserData from "@/mixins/currentUser";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    profile,
    loader,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [currentUserData],
  data() {
    return {
      loading: false,
      isloading: false,
      //errors: [],
      currentUserData: "",
      companyName: "",
      companyCity: "",
      companyHousenumber: "",
      companyStreet1: "",
      compnayStreet2: "",
      companyState: "",
      companyZip: "",
      companyPhone: "",
      companyEmail: "",
      agreeCategoryType: "",
      AgreementFrom: "",
      AgreementTo: "",
      companyUserName: "",
      enterEmail: null,
      newPassword: null,
      enterOTP: null,
      resetRef: null,
      showPassword: false,
    };
  },
  computed: {
    diffInDays() {
      const moment = require("moment");
      const diffInDays = moment(this.AgreementTo).diff(
        moment(this.AgreementFrom),
        "months"
      );
      return diffInDays;
    },
    ...mapState({
      resetPasswordOtp: (state) => state.tenantProfile.resetPasswordOtp,
    }),
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    onClickChangePassword() {
      this.enterEmail = "";
      this.$refs["change-password"].show();
    },
    async generateOTP() {
      this.newPassword = "";
      this.enterOTP = "";
      this.$refs["change-password"].hide();
      try {
        this.isLoading = true;
        const payload = {
          email: this.enterEmail,
        };
        const result = await this.$store.dispatch(
          "tenantProfile/resetRequest",
          payload
        );

        this.$swal({
          group: "item",
          title: "Well Done !",
          text: "OTP has been sent to your registered Email Address.",
          type: "success",
          timer: 1200,
        });
        this.$refs["new-password"].show();
      } catch (err) {
        this.$swal({
          group: "item",
          title: "Please Try Again ^_^",
          text: err.message.message,
          type: "error",
          timer: 1200,
        });
      } finally {
        this.isLoading = false;
      }
    },
    async savePassword() {
      try {
        this.isLoading = true;
        const payload = {
          password: this.newPassword,
          resetRef: this.resetPasswordOtp.resetRef,
          verificationCode: this.enterOTP,
        };
        const result = await this.$store.dispatch(
          "tenantProfile/resetPassword",
          payload
        );
        this.$swal({
          group: "item",
          title: "Well Done !",
          text: "Password changed successfully",
          type: "success",
          timer: 1100,
        });
        this.$refs["new-password"].hide();
      } catch (err) {
        this.$swal({
          group: "item",
          title: "Please Try Again",
          text: err.message.message,
          type: "error",
          timer: 1100,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    const tenantProfileData = await this.$store.dispatch(
      "tenant/getTenantDetailByID",
      this.$currentUserData._id
    );
    this.companyName = tenantProfileData?.response?.company?.name || "";
    this.companyCity = tenantProfileData?.response?.address?.city || "";
    this.companyHousenumber =
      tenantProfileData?.response?.address?.houseNumber || "";
    this.companyStreet1 = tenantProfileData?.response?.address?.street1 || "";
    this.compnayStreet2 = tenantProfileData?.response?.address?.street2 || "";
    this.companyState = tenantProfileData?.response?.address?.state || "";
    this.companyZip = tenantProfileData?.response?.address?.zip || "";
    this.companyPhone =
      tenantProfileData?.response?.authentication?.phone || "";
    this.companyEmail =
      tenantProfileData?.response?.authentication?.email || "";
    this.agreeCategoryType =
      tenantProfileData?.response?.agreement?.businessSegmentInfo[0]
        ?.categoryType || "";
    this.AgreementFrom =
      tenantProfileData?.response?.agreement?.valid?.from || "";
    this.AgreementTo = tenantProfileData?.response?.agreement?.valid?.to || "";
    this.companyUserName =
      tenantProfileData?.response?.authentication?.userName || "";
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style scoped>
.dotted-border-right {
  border-right: 1px dashed #c2c2c2;
}
.dotted-border-bottom {
  border-bottom: 1px dashed #c2c2c2;
}
.profile-edit-head {
  padding: 0;
  margin: 0;
}
.profile-edit-head li {
  display: inline-block;
  margin-right: 25px;
}
.validate-error {
  color: red;
  display: block;
  margin-bottom: 12px;
}
:deep .close {
  color: rgb(168, 3, 3);
}
.password-input-container {
  position: relative;
}

.toggle-password-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
